"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toaster = void 0;

var React = require("react");

var mitt_1 = require("mitt");

var FiX_1 = require("@react-icons/all-files/fi/FiX");

var react_transition_group_1 = require("react-transition-group");

var styled_components_1 = require("styled-components");

var Portal_1 = require("./Portal");

var utils_1 = require("../utils");

var emitter = mitt_1.default();
var TOAST_EVENT = 'fire-toast-event';
var DEFAULT_TIMEOUT_MS = 4000;
var ANIMATION_DURATION_MS = 200;
var CloseButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 13px;\n  border: none;\n  z-index: 1;\n  cursor: pointer;\n  background: transparent;\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 13px;\n  border: none;\n  z-index: 1;\n  cursor: pointer;\n  background: transparent;\n"])));
var Toast = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  var themeStyles = utils_1.getComponentThemeStyles(p.theme, 'Toaster', p.variant, 'default');
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      opacity: 0;\n      position: relative;\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n\n      transition: ", "ms;\n      ", "\n    "], ["\n      opacity: 0;\n      position: relative;\n      ", ";\n      ", ";\n      ", ";\n      ", ";\n\n      transition: ", "ms;\n      ", "\n    "])), p.transitionState === 'entering' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          opacity: 1;\n          animation: ", "ms ", ";\n        "], ["\n          opacity: 1;\n          animation: ", "ms ", ";\n        "])), ANIMATION_DURATION_MS, utils_1.getAnimation('fadeInDown')), p.transitionState === 'entered' && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          opacity: 1;\n        "], ["\n          opacity: 1;\n        "]))), p.transitionState === 'exiting' && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          animation: ", "ms ", ";\n        "], ["\n          animation: ", "ms ", ";\n        "])), ANIMATION_DURATION_MS, utils_1.getAnimation('fadeOutUp')), p.transitionState === 'exited' && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          opacity: 0;\n        "], ["\n          opacity: 0;\n        "]))), ANIMATION_DURATION_MS, themeStyles);
});
var ToasterContainer = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  z-index: 1000;\n  position: fixed;\n"], ["\n  ", ";\n  z-index: 1000;\n  position: fixed;\n"])), function (p) {
  return p.position === 'topRight' && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      right: 10px;\n      top: 10px;\n    "], ["\n      right: 10px;\n      top: 10px;\n    "])));
});
var Fix = styled_components_1.default(FiX_1.FiX)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) {
  return p.theme.colors.greyLightest;
});

function SingleToast(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      value = _a.value,
      transitionState = _a.transitionState,
      onClick = _a.onClick;
  return React.createElement(Toast, {
    transitionState: transitionState,
    variant: variant
  }, value, React.createElement(CloseButton, {
    onClick: onClick
  }, React.createElement(Fix, {
    size: 15
  })));
}

function Provider() {
  var _a = React.useState([]),
      queue = _a[0],
      updateQueue = _a[1];

  var handleRemove = function handleRemove(idToRemove) {
    updateQueue(function (queue) {
      return queue.filter(function (item) {
        return item.id !== idToRemove;
      });
    });
  };

  React.useEffect(function () {
    var handleToastEvent = function handleToastEvent(payload) {
      updateQueue(__spreadArrays(queue, [payload]));
      setTimeout(function () {
        var idToRemove = payload.id;
        handleRemove(idToRemove);
      }, DEFAULT_TIMEOUT_MS);
    };

    emitter.on(TOAST_EVENT, handleToastEvent);
    return function () {
      emitter.off(TOAST_EVENT, handleToastEvent);
    };
  });
  return React.createElement(Portal_1.Portal, null, React.createElement(ToasterContainer, {
    position: "topRight"
  }, React.createElement(react_transition_group_1.TransitionGroup, null, queue.map(function (payload, index) {
    return React.createElement(react_transition_group_1.Transition, {
      key: index,
      timeout: ANIMATION_DURATION_MS,
      unmountOnExit: true,
      appear: true
    }, function (state) {
      return React.createElement(SingleToast, __assign({
        onClick: function onClick() {
          return handleRemove(payload.id);
        },
        transitionState: state
      }, payload));
    });
  }))));
}

function alert(payload) {
  var id = utils_1.generateUniqueID();
  emitter.emit(TOAST_EVENT, __assign(__assign({}, payload), {
    id: id
  }));
}

exports.Toaster = {
  Provider: Provider,
  alert: alert
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;